module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACEAAAANCAYAAAAnigciAAAAAXNSR0IArs4c6QAAAPBJREFUOBG1k70OAUEUhf0khEJoJBJKlU40GoVa1N7CA2iFxiuIZxCtQvAAEhIvQKEQHQ1Z34ZNdsVkZ+5wky97Z+4950yzkYhFOY5Th66FhZ2U8CTs4QplOzehmuABeLWiiQmtZDICG3D3XvD+9mRuAhWBeTh+PMA9PqApsDSTEBKHOajqxKBo5mq4TcBYle6739HnDK311jHu+4LC2jULKT1nzS0Mh2GpX+ZL7rKaEeo1TBIwAWltEZbUCSETxBXYSNN9ugt9JyQuOEbg/oIjuMEva4ZZNZj2OkUZZGgLUIMWtCEN/6oFxlNwvwc4PwFX4xBIKc2ReQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/v2/popover-arrow-white.png
// module id = 310
// module chunks = 33